export default "/images/envelope-open.svg?1d452dae66aa0af6273d3b0da16f249f";